import { Tag } from '@cian/components';
import * as React from 'react';

import { IIsFirstFloorTag } from '../../../state/tags/definitions/is_first_floor';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IIsFirstFloorTagItemProps {
  tag: IIsFirstFloorTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const IsFirstFloorTagItem = ({ tag, onDeleteClick, withNewTag }: IIsFirstFloorTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      {tag.value ? 'Первый этаж' : 'Не первый этаж'}
    </TagComponent>
  );
};
